
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
// [AMapReplace->OrderArea 20260825] 原地图选点组件 PickAddressInMap 替换为 OrderArea 省市区选择器
import OrderArea from '@/views/order/components/OrderArea.vue';
import OrderAddressCustom from '@/views/order/components/OrderAddressCustom.vue';

@Component({
  name: 'AddAddress',
  components: {
    OrderAddressCustom,
    OrderArea
  }
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => ({})
  })formAddress!:any;

  @Prop({
    type: Boolean,
    default: false
  })isEditAddress!:Boolean;

  @Prop({
    type: Boolean,
    default: false
  })dialogAddressVisible!:Boolean;

  private showAddressDialog = false;
  private addressForAdd:boolean=false;
  private userInfo:any=UserModule.getUserInfo;

  // 选择地址 打开地图dialog
  private areaCilck(val:boolean) {
    this.addressForAdd = val;
    if (val) {
      if (parseInt(this.formAddress.address_type) === 1) {
        this.showAddressDialog = true;
      } else {
        this.areaCustomVisible = true;
      }
    } else {
      this.showAddressDialog = true;
    }
  }

  // [AMapReplace->OrderArea 20260825] 原地图选点回调 positionPicker 改为省市区选择回调 areaSave；
  // OrderArea 仅提供省市区及 adcode，latitude/longitude/address 不再由组件回填
  private saveAreaHandle(area: any) {
    if (area) {
      if (this.addressForAdd) {
        this.formAddress.province_name = area.province_name;
        this.formAddress.province = area.province;
        this.formAddress.city_name = area.city_name;
        this.formAddress.city = area.city;
        this.formAddress.district_name = area.district_name;
        this.formAddress.district = area.district;
        this.$set(this.formAddress, 'addressStr', area.province_name + '  ' + area.city_name + '  ' + area.district_name);
      } else {
        this.userInfo.province_name = area.province_name;
        this.userInfo.province = area.province;
        this.userInfo.city_name = area.city_name;
        this.userInfo.city = area.city;
        this.userInfo.district_name = area.district_name;
        this.userInfo.district = area.district;
        this.userInfo.adcode = area.adcode;
        this.$set(this.userInfo, 'addressStr', area.province_name + '  ' + area.city_name + '  ' + area.district_name);
      }
    }
  }

  // 地图dialog 关闭
  private closeAddress(close: boolean) {
    this.showAddressDialog = close;
  }

  private areaCustomVisible = false
  private saveAreaCustomHandle(value:any) {
    this.areaCustomVisible = false;
    if (value) {
      if (value.pBean && value.pBean1) {
        this.formAddress.one_address_name = JSON.parse(value.pBean).address;
        this.formAddress.one_address_id = JSON.parse(value.pBean).id;
        this.formAddress.two_address_name = JSON.parse(value.pBean1).address;
        this.formAddress.two_address_id = JSON.parse(value.pBean1).id;
        this.formAddress.three_address_name = value.address;
        this.formAddress.three_address_id = value.id;
      } else if (value.pBean) {
        this.formAddress.one_address_name = JSON.parse(value.pBean).address;
        this.formAddress.one_address_id = JSON.parse(value.pBean).id;
        this.formAddress.two_address_name = value.address;
        this.formAddress.two_address_id = value.id;
        this.formAddress.three_address_name = '';
        this.formAddress.three_address_id = '0';
      } else {
        this.formAddress.one_address_name = value.address;
        this.formAddress.one_address_id = value.id;
        this.formAddress.two_address_name = '';
        this.formAddress.two_address_id = '0';
        this.formAddress.three_address_name = '';
        this.formAddress.three_address_id = '0';
      }
    }
    this.$set(this.formAddress, 'addressStr', this.formAddress.one_address_name + '  ' + this.formAddress.two_address_name + '  ' + this.formAddress.three_address_name);
  }
  private closeAreaCustomHandle(value:boolean) {
    this.areaCustomVisible = value;
  }

  private addAddress() {
    if (!this.formAddress.address) {
      this.showErrorMsg('请输入详细地址');
      return;
    }
    let parmas:any = {};
    parmas.user_id = UserModule.getUserId;
    parmas.address = this.formAddress.address;
    parmas.name = this.formAddress.name;
    parmas.mobile = this.formAddress.mobile;
    parmas.phone_num = this.formAddress.telephone;
    parmas.latitude = this.formAddress.latitude;
    parmas.longitude = this.formAddress.longitude;
    parmas.adcode = this.formAddress.adcode;

    if (parseInt(this.formAddress.address_type) === 3) {
      parmas.one_address_id = this.formAddress.one_address_id;
      parmas.one_address_name = this.formAddress.one_address_name;
      parmas.two_address_id = this.formAddress.two_address_id;
      parmas.two_address_name = this.formAddress.two_address_name;
      parmas.three_address_id = this.formAddress.three_address_id;
      parmas.three_address_name = this.formAddress.three_address_name;
    } else {
      parmas.province = this.formAddress.province;
      parmas.city = this.formAddress.city;
      parmas.district = this.formAddress.district;
      parmas.province_name = this.formAddress.province_name;
      parmas.city_name = this.formAddress.city_name;
      parmas.district_name = this.formAddress.district_name;
    }
    if (this.isEditAddress) {
      parmas.id = this.formAddress.address_id;
    }
    this.$emit('addAddress', parmas);
  }

  private close() {
    this.$emit('close', false)
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
